module.exports = __webpack_public_path__ + "static/media/coffer_screenshot.6a300329.png";